import { render, staticRenderFns } from "./BulkSpecialHoursEditor.vue?vue&type=template&id=5608837d&scoped=true&"
import script from "./BulkSpecialHoursEditor.vue?vue&type=script&lang=js&"
export * from "./BulkSpecialHoursEditor.vue?vue&type=script&lang=js&"
import style0 from "./BulkSpecialHoursEditor.vue?vue&type=style&index=0&id=5608837d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5608837d",
  null
  
)

export default component.exports